import { useRef } from 'react';
import { IFile, IRightToRepresent, uploadFileToS3, uploadRtrForSubmissions } from 'wisestep-api';
import { FileTypeVariants, WsFileUpload } from 'wisestep-base';

import { success, failed } from '../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../utils/NotificationStore';

interface RTRProps {
  rowIndex: number;
  fileId: string;
  refresh: (file: IRightToRepresent) => void;
}

const RTR = ({ rowIndex, fileId, refresh }: RTRProps) => {
  const file = useRef<IFile>({
    name: '',
    location: '',
  });

  const setNotification = useNotificationStore((state) => state.setNotification);

  const onFileUpload = async (files: File[]) => {
    try {
      const response = await uploadFileToS3(files[0]);
      file.current = { name: files[0]?.name, location: response.split('?')[0] };
      setNotification(success('File Upload Success!'));
      saveUploadedRTR();
    } catch {
      setNotification(failed('File Upload Failed!'));
    }
  };
  const saveUploadedRTR = async () => {
    try {
      if (fileId && rowIndex > -1) {
        const payload: IRightToRepresent = {
          rtrFileOriginalName: file.current.name,
          rtrFileLocation: file.current.location,
          rtrConsent: true,
          rtrFileUploadedOn: new Date(),
        };
        await uploadRtrForSubmissions(rowIndex, fileId, payload);
        setNotification(success('RTR uploaded successfully !!'));
        refresh(payload);
      } else {
        setNotification(failed('Few details are missing to upload RTR, Please try again !!'));
      }
    } catch {
      setNotification(failed('Error in RTR upload , Please try again !!'));
    }
  };
  return (
    <WsFileUpload
      name="attachment"
      placeholderText=""
      onUpload={onFileUpload}
      fileTypes={FileTypeVariants.IMAGES}
      Icon={<></>}
      bgRequired={false}
    />
  );
};

export default RTR;
